import React, { memo } from 'react'
import { Box } from 'transfix-ui/core'
import { IBidRateCoachGrades, Maybe } from 'types/graphqlTypes'
import { getScoreCopy, RateCoachGauge } from 'apps/marketplace/components/RateCoachGauge'

export interface IRateCoachCardRowProps {
  rateCoachGrade: Maybe<IBidRateCoachGrades>
}

export const RateCoachCardRow = memo<IRateCoachCardRowProps>(({ rateCoachGrade }) => (
  <Box display='flex' alignItems='center' justifyContent='space-between'>
    <Box pr={2}>
      <RateCoachGauge score={rateCoachGrade} />
    </Box>
    {getScoreCopy(rateCoachGrade)}
  </Box>
))
